<script setup lang="ts">
import { ConfirmModal } from '@collector/shared-ui'
</script>

<template>
  <ConfirmModal>
    <template #title>Are you sure you want to leave Statistics?</template>
    <div>Not saved data will be lost.</div>
  </ConfirmModal>
</template>
